import React from 'react';

function SvgIcon({ children, className, style, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
      aria-hidden
      {...props}
    >
      {children}
    </svg>
  );
}

/** Papas fritas — snacks, acompañamientos, sides. */
export function PapasFritasIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M7 20h10" />
      <path d="M8 20V11" />
      <path d="M10.5 20V9" />
      <path d="M13 20V10" />
      <path d="M15.5 20V8" />
      <path d="M6 20h12a1 1 0 0 0 1-1v-2H5v2a1 1 0 0 0 1 1z" />
    </SvgIcon>
  );
}

/** Maki / sushi roll. */
export function SushiIcon(props) {
  return (
    <SvgIcon {...props}>
      <circle cx="12" cy="12" r="7" />
      <circle cx="12" cy="12" r="2.5" />
      <path d="M5 12h3" />
      <path d="M16 12h3" />
    </SvgIcon>
  );
}

/** Temaki / hand roll (cono). */
export function HandRollIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M12 4 19 18H5L12 4z" />
      <path d="M8.5 14h7" />
      <path d="M9.5 11h5" />
    </SvgIcon>
  );
}

/** Taco. */
export function TacoIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M5 14c2-4 12-4 14 0" />
      <path d="M6 14c1.5 2 10.5 2 12 0" />
      <path d="M9 12h.01" />
      <path d="M12 11h.01" />
      <path d="M15 12h.01" />
    </SvgIcon>
  );
}

/** Waffle. */
export function WaffleIcon(props) {
  return (
    <SvgIcon {...props}>
      <rect x="5" y="5" width="14" height="14" rx="2" />
      <path d="M5 11h14" />
      <path d="M5 17h14" />
      <path d="M11 5v14" />
      <path d="M17 5v14" />
    </SvgIcon>
  );
}

/** Completo / hot dog chileno. */
export function CompletoIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M4 12c2-2 14-2 16 0" />
      <path d="M4 14c2 2 14 2 16 0" />
      <path d="M7 11v2" />
      <path d="M10 10v4" />
      <path d="M14 10v4" />
    </SvgIcon>
  );
}

/** Pollo asado / a la brasa. */
export function PolloAsadoIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M12 4c-2 2-3 4-3 7a3 3 0 0 0 6 0c0-3-1-5-3-7z" />
      <path d="M9 18h6" />
      <path d="M10 18v2" />
      <path d="M14 18v2" />
      <path d="M16 8c1 1 2 2 2 4" />
      <path d="M8 8C7 9 6 10 6 12" />
    </SvgIcon>
  );
}

/** Pastas / fideos. */
export function PastaIcon(props) {
  return (
    <SvgIcon {...props}>
      <circle cx="12" cy="12" r="7" />
      <path d="M8.5 9.5c1.5 2 5.5 2 7 0" />
      <path d="M7.5 12.5c2 2.5 7 2.5 9 0" />
      <path d="M8.5 15.5c1.5 2 5.5 2 7 0" />
    </SvgIcon>
  );
}
